// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoadingDots_loader__LzTdo","spin":"LoadingDots_spin__1Sj1r","rotate":"LoadingDots_rotate__OhBCQ","rotateccw":"LoadingDots_rotateccw__DJf6l"};